import { render, staticRenderFns } from "./EmArchFixedAssetDisposalTask.vue?vue&type=template&id=5080161c&scoped=true&"
import script from "./EmArchFixedAssetDisposalTask.vue?vue&type=script&lang=js&"
export * from "./EmArchFixedAssetDisposalTask.vue?vue&type=script&lang=js&"
import style0 from "./EmArchFixedAssetDisposalTask.vue?vue&type=style&index=0&id=5080161c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5080161c",
  null
  
)

export default component.exports